const WEMOB_HOSTNAMES = ["cpms-wemob.tupimob.com", "wemob.tupinrg.dev"];

export const isWemob = WEMOB_HOSTNAMES.includes(window.location.hostname);
